import { RocheUIGrid } from '@repo/roche-ui';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import React, { FC } from 'react';
import { blokToComponent } from '../../helpers/blok-to-component';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { LanguageService } from '../../services/language';

const gridLayouts = [
  'roche-grid-1-4-1-6',
  'roche-grid-12',
  'roche-grid-3-1-5-3',
  'roche-grid-3-3-3-3',
  'roche-grid-4-4-4',
  'roche-grid-4-8',
  'roche-grid-5-1-6',
  'roche-grid-5-7',
  'roche-grid-6-1-4-1',
  'roche-grid-6-6',
  'roche-grid-7-5',
  'roche-grid-8-4',
  'roche-grid-8',
  'roche-grid-6',
  'roche-grid-6-1-5',
  'roche-grid-8-1-3',
  'roche-grid-7-1-4',
];

const storyblokGridAreasMap = new Map([
  ['slotted_left', 'left'],
  ['slotted_center_left', 'center-left'],
  ['slotted_center', 'center'],
  ['slotted_center_right', 'center-right'],
  ['slotted_right', 'right'],
  ['slotted', 'full'],
]);

type RocheGridProps = BlokToComponentProps<{
  component: string;
  fullWidth: boolean;
  color: string;
  hideInPrintView?: boolean;
}>;

const RocheGrid: FC<RocheGridProps> = ({ blok, storyId, getComponent }) => {
  const gridChildren: StoryblokComponent<string>[] = [];

  storyblokGridAreasMap.forEach((slot: string, slotKey: string): void => {
    if (blok[slotKey]) {
      gridChildren.push(
        blok[slotKey].map((component: StoryblokComponent<string>) =>
          blokToComponent(
            {
              getComponent,
              blok: component,
              slot,
              storyId,
            },
            'grid',
          ),
        ),
      );
    }
  });

  const isRightToLeft = LanguageService.isRightToLeft();

  return (
    <RocheUIGrid
      layout={blok.component}
      fullWidth={blok.fullWidth}
      isRightToLeft={isRightToLeft}
      backgroundColor={blok.color ?? 'transparent'}
      hideInPrintView={blok.hideInPrintView}
    >
      {gridChildren}
    </RocheUIGrid>
  );
};

// Every grid-layout is an individual RocheGrid component
// We are exporting them as a map for easy access
export const gridComponents = gridLayouts.reduce(
  (accumulator, componentName) => ({
    ...accumulator,
    [componentName]: RocheGrid,
  }),
  {},
);
